export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-2.a16cabbf.png";